/**
 * Update threat event documents (arbitium_threat_events).
 * Blueprint: arbitium_threat_events.json.
 */

import { putRingDoc } from '../core';

const RING_THREAT_EVENTS = 'arbitium_threat_events';

export interface UpdateThreatEventPayload {
  started_at?: string;
  finished_at?: string;
  status?: 'active' | 'in_progress' | 'remediated' | 'error' | 'folded' | 'reopened';
  classification?: string;
  risk_level?: string;
  is_test?: boolean;
  [key: string]: unknown;
}

/**
 * Updates an arbitium_threat_events document (e.g. started_at, finished_at). Partial update.
 */
export async function updateThreatEvent(
  threatEventId: string,
  payload: UpdateThreatEventPayload
): Promise<boolean> {
  const res = await putRingDoc(RING_THREAT_EVENTS, threatEventId, payload);
  return res.success;
}
